import { v2Request } from './client';

function landingQuery(storeId) {
  if (storeId == null || String(storeId).trim() === '') return '';
  return `?storeId=${encodeURIComponent(String(storeId).trim())}`;
}

export async function getGenericLanding({ storeId } = {}) {
  return v2Request(`/api/landing${landingQuery(storeId)}`);
}

export async function getCustomerLanding({ mobile, storeId } = {}) {
  return v2Request(`/api/landing/${mobile}${landingQuery(storeId)}`);
}

/**
 * Normalize Pilot POST /api/pods/getNearestStore flat store payload for v2_location.
 * @param {Record<string, unknown>} raw
 */
export function normalizePodStoreResponse(raw) {
  const id = raw.storeId ?? raw.id;
  const storeId = id != null && String(id).trim() !== '' ? String(id) : null;
  const podId =
    raw.podId != null && String(raw.podId).trim() !== '' ? String(raw.podId) : null;

  const store = storeId
    ? {
        ...raw,
        id: storeId,
        storeId,
        podId,
      }
    : null;

  return {
    store,
    podId,
    distanceMeters: raw.distance != null ? Number(raw.distance) : null,
    outsidePods: false,
  };
}

/**
 * Nearest store for GPS coords via delivery pods — POST /api/pods/getNearestStore.
 * @returns {{ store: object|null, podId: string|null, distanceMeters: number|null, outsidePods: boolean }}
 */
export async function findNearestStoreByCoords({ lat, lng }) {
  const raw = await v2Request('/api/pods/getNearestStore', {
    method: 'POST',
    body: { lat, lng },
  });

  if (raw?.errorCode === 'ERR_NEW_ORDER') {
    return { store: null, podId: null, distanceMeters: null, outsidePods: true };
  }

  return normalizePodStoreResponse(raw);
}
